import 'angular:locale/data:nb';
import 'zone.js';(globalThis.$localize ??= {}).locale = "nb";
